import React, { useEffect } from "react";
import "../privacy.css";
import ScrollTop from "../components/ScrollTop";

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="containers">
        <h1>Terms of Service</h1>
        <h5 className="mt-4">INTRODUCTION</h5>
        <p>
          Please read these Terms of Service ("Terms") carefully before
          ordering. By ordering any item from our website or mobile applications
          ("Services"), you agree to be bound by these Terms.
        </p>

        <h5 className="mt-4">ABOUT US</h5>
        <p>
          <strong>Halalmeats.store</strong>, in partnership with local butchers
          and grocery stores, provides website services that showcase products
          available for purchase. These websites serve as a platform to display
          product information and include links directing users to our
          affiliated website, <strong>www.meatwala.co.uk</strong>, where
          purchases can be made.
        </p>
        <p>
          We are Meatwala High Wycombe Ltd, a company registered in England and
          Wales (Company Number: 15260965), with our registered office at 6
          Shelburne Court, High Wycombe, England, HP12 3NH ("Meatwala," "we,"
          "us," "our"). To contact us, please email{" "}
          <a href="contact@meatwala.co.uk">contact@meatwala.co.uk</a>.
        </p>
        <p>
          These Terms were last updated on [3rd March 2025], and they are the
          current and valid version.
        </p>
        <p>
          The Meatwala name, logo, marks, emblems, and images are the copyright
          of Meatwala High Wycombe Ltd, © 2024. All Rights Reserved.
        </p>
        <p>
          The following additional policies apply to your use of our Services
          and form part of these Terms:{" "}
          <ul>
            <li>Privacy Policy</li>
            <li>Cookie Policy</li>
            <li>
              App Privacy Policy (if using our iOS or Android mobile
              applications)
            </li>
            <li>
              End User License Agreement (EULA) (if using our iOS or Android
              mobile applications)
            </li>
          </ul>
        </p>

        <h5 className="mt-4">OUR SERVICES</h5>
        <p>
          Meatwala High Wycombe Ltd provides an on-demand delivery service via a
          mobile application or website (collectively, the “Platform”). The
          Platform connects customers with local halal meat and grocery stores
          (“Partners”). It also connects Partners to independent contractor
          drivers for deliveries. Meatwala High Wycombe Ltd is not a retailer,
          grocery store, or food delivery service provider.
        </p>

        <h5 className="mt-4">PURPOSE</h5>
        <p>
          Our Platform facilitates convenient online ordering and delivery
          services by linking customers with local halal meat and grocery
          stores. Meatwala High Wycombe Ltd processes orders on behalf of our
          Partners and facilitates their delivery.
        </p>

        <h5 className="mt-4">SERVICE AVAILABILITY</h5>
        <p>
          Each Partner has a designated delivery area. If you live outside these
          areas, a message will appear on-screen notifying you that ordering
          online is not possible. Operating hours vary based on local trading
          conditions and Partner availability.
        </p>

        <h5>ORDERS</h5>
        <p>
          <ul>
            <li>Minimum order values are set by Partners.</li>
            <li>
              Upon placing an order, you will receive an email confirmation
              ("Confirmation Email") from us on behalf of the Partner.
            </li>
            <li>
              The contract for your order is between you and the Partner, only
              forming upon receipt of the Confirmation Email.
            </li>
            <li>
              Ensure you provide accurate email, delivery address, and telephone
              number details.
            </li>
            <li>
              If you fail to respond to delivery attempts within 5 minutes, the
              driver may leave, and you will be charged for the order and
              delivery.
            </li>
            <li>
              In case of delays beyond 55 minutes, we will attempt to contact
              you with an update.
            </li>
          </ul>
        </p>

        <h5 className="mt-4">AVAILABILITY AND DELIVERY</h5>
        <p>
          We aim to provide the best delivery service possible. However, factors
          such as traffic and weather may occasionally impact delivery times. If
          delays occur, we will notify you where possible.
        </p>

        <h5 className="mt-4">ADDITIONS TO ORDERS</h5>

        <p>
          Once an order is confirmed, additional items require a new order with
          potential additional delivery charges.
        </p>

        <h5 className="mt-4">CANCELLATION </h5>
        <p>
          <ul>
            <li>
              You may cancel an order before preparation begins and receive a
              refund.
            </li>
            <li>Once an order has started preparation, full charges apply.</li>
            <li>
              Meatwala High Wycombe Ltd and our Partners reserve the right to
              cancel orders at any time. If this occurs, a full refund will be
              issued.
            </li>
          </ul>
        </p>

        <h5 className="mt-4">PRICE AND PAYMENT</h5>
        <p>
          <ul>
            <li>Prices include VAT and are subject to change.</li>
            <li>Payments are made via debit/credit card.</li>
            <li>
              Once confirmed, payments are processed by Meatwala High Wycombe
              Ltd, which forwards funds to the Partner.
            </li>
            <li>
              A delivery fee may apply and will be displayed before order
              completion.
            </li>
          </ul>
        </p>

        <h5 className="mt-4">ACCESSING OUR SERVICES </h5>
        <p>
          <ul>
            <li>
              Our Platform is available on a temporary basis and may be
              withdrawn or amended at any time.
            </li>
            <li>You must be over 18 to place orders.</li>
            <li>Drivers may request ID verification for restricted items.</li>
            <li>
              You are responsible for maintaining the security of your login
              details.
            </li>
          </ul>
        </p>

        <h5 className="mt-4">ALLERGIES</h5>
        <p>
          If you have dietary restrictions or allergies, please contact us
          before placing an order.
        </p>

        <h5 className="mt-4">ACCEPTABLE USE</h5>
        <p>
          You must use our Services lawfully. Prohibited activities include:
        </p>
        <p>
          <ul>
            <li>Violating laws or regulations.</li>
            <li>Uploading defamatory, offensive, or illegal content.</li>
            <li>Attempting to disrupt our Platform’s operation.</li>
          </ul>
        </p>

        <h5 className="mt-4">CONTENT AND FEATURES</h5>
        <p>
          We may provide interactive features on our website and App. Content
          posted by users must:
        </p>
        <p>
          <ul>
            <li>Be accurate (for factual statements).</li>
            <li>
              Not contain hate speech, violence, or discriminatory material.
            </li>
            <li>Not infringe intellectual property rights.</li>
          </ul>
        </p>

        <h5 className="mt-4">SUSPENSION AND TERMINATION</h5>
        <p>
          We may suspend or terminate your access if you violate these Terms.
          Actions we may take include:
        </p>

        <p>
          <ul>
            <li>Immediate termination of access.</li>
            <li>Legal action for damages.</li>
            <li>Reporting to law enforcement where necessary.</li>
          </ul>
        </p>

        <h5 className="mt-4">INTELLECTUAL PROPERTY </h5>
        <p>
          All website, app, and platform content is owned or licensed by
          Meatwala High Wycombe Ltd. Users may not copy, reproduce, or use any
          content without our consent.
        </p>

        <h5 className="mt-4">LIABILITY LIMITATIONS </h5>
        <p>
          1.We are not liable for errors, omissions, or service interruptions
          beyond our control.
        </p>
        <p>
          2. We do not guarantee uninterrupted access to our website and App.
        </p>
        <p>
          3. We are not responsible for indirect losses, including:
          <ul>
            <li>Loss of profits or business.</li>
            <li>Data loss.</li>
            <li>Business interruptions.</li>
          </ul>
        </p>
        <p>
          4. These Terms do not limit liability for personal injury, fraud, or
          illegal activities.
        </p>

        <h5 className="mt-4">CHANGES TO THESE TERMS </h5>
        <p>
          We reserve the right to update these Terms at any time. Updates will
          be posted on our website and take effect immediately upon publication.
        </p>

        <h5 className="mt-4">INFORMATION COLLECTION </h5>
        <p>We collect personal data as outlined in our Privacy Policy.</p>

        <h5 className="mt-4">UPLOADING MATERIAL</h5>
        <p>
          Any content you submit to our Services is considered non-confidential,
          and we may use it for business purposes.
        </p>

        <h5 className="mt-4">GOVERNING LAW & JURISDICTION</h5>
        <p>
          <ul>
            <li>These Terms are governed by the laws of England and Wales.</li>
            <li>
              If a dispute arises, both parties agree to resolve it amicably
              within 60 days before seeking legal action.
            </li>
            <li>
              If necessary, disputes will be settled in the courts of England
              and Wales.
            </li>
          </ul>
        </p>
        <p className="mb-5">
          By using our Services, you confirm your acceptance of these Terms.
        </p>
      </div>
      <ScrollTop />
    </>
  );
};

export default TermsConditions;
